import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import dopa from "../views/Dopa.vue";
import dobu from "../views/Dobu.vue";
import nore from "../views/Nore.vue";
import nica from "../views/Nica.vue";
import crcl from "../views/Crcl.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/dopa",
    name: "dopa",
    component: dopa
  }
  ,
  {
    path: "/dobu",
    name: "dobu",
    component: dobu
  }
  ,
  {
    path: "/nore",
    name: "nore",
    component: nore
  }
  ,
  {
    path: "/nica",
    name: "nica",
    component: nica
  },
  {
    path: "/crcl",
    name: "crcl",
    component: crcl
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
